module.exports = __webpack_public_path__ + "static/media/garuda-bnb.875543f2.png";